import { render, staticRenderFns } from "./ProductosCom.vue?vue&type=template&id=17ff9d70&"
import script from "./ProductosCom.vue?vue&type=script&lang=js&"
export * from "./ProductosCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports